// extracted by mini-css-extract-plugin
export default {"topMenuText":"BurgerMenu_topMenuText__tCoNy","topButtonText":"BurgerMenu_topButtonText__Z5lvl","topButtons":"BurgerMenu_topButtons__nQ4+R"};